<template>
  <div id="search-results">
    <h3 class="mb-3">
      {{ $t("navigation." + ROUTE_FOOD) }}
    </h3>

    <transition-group mode="out-in" name="move" tag="div" class="row">
      <FoodCard
        v-for="keyObj in filteredFoodKeys"
        :key="keyObj.key"
        :id="keyObj.key"
        :foodItem="food[keyObj.key]"
      ></FoodCard>
    </transition-group>

    <p v-if="!filteredFoodKeys.length">
      {{ $t("search.noResultsFood") }}
    </p>

    <h3 class="mb-3">
      {{ $t("navigation." + ROUTE_CATEGORIES) }}
    </h3>

    <transition-group mode="out-in" name="move" tag="div" class="row">
      <CategoryCard
        v-for="keyObj in filteredCategoriesKeys"
        :key="keyObj.key"
        :id="keyObj.key"
        :category="categories[keyObj.key]"
      ></CategoryCard>
    </transition-group>

    <p v-if="!filteredCategoriesKeys.length">
      {{ $t("search.noResultsCategories", [searchQuery]) }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FoodCard from "./../food/FoodCard";
import CategoryCard from "./../categories/CategoryCard";
import { ROUTE_FOOD, ROUTE_CATEGORIES } from "./../../constants";
import { searchInObjectSubProperties } from "./../../tools";

export default {
  name: "SearchResults",
  components: {
    FoodCard,
    CategoryCard
  },
  data() {
    return {
      ROUTE_FOOD,
      ROUTE_CATEGORIES
    };
  },
  computed: {
    ...mapGetters(["food", "categories", "searchQuery"]),
    filteredFoodKeys() {
      return searchInObjectSubProperties(this.food, this.searchQuery, {
        allowedProps: ["name", "notes"]
      });
    },
    filteredCategoriesKeys() {
      return searchInObjectSubProperties(this.categories, this.searchQuery, {
        allowedProps: ["name"]
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
